var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    width: 28,
    height: 17.6471,
    rx: 3.6,
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M16.3039 8.82375C16.3039 10.7275 15.4007 12.4249 13.998 13.52C15.054 14.3429 16.3629 14.7998 17.7216 14.7998C21.044 14.7998 23.7469 12.119 23.7469 8.82375C23.7469 5.52853 21.044 2.84766 17.7216 2.84766C16.3629 2.84766 15.054 3.30458 14.0001 4.12577C15.4006 5.22256 16.3039 6.91998 16.3039 8.82375Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M16.3036 8.82375C16.3036 6.91998 15.4003 5.22256 13.9977 4.12745C12.9726 3.32701 11.6812 2.84766 10.2782 2.84766C6.95589 2.84766 4.25293 5.52853 4.25293 8.82375C4.25293 12.119 6.95589 14.7998 10.2782 14.7998C11.6812 14.7998 12.9726 14.3205 13.9977 13.52C15.4003 12.4249 16.3036 10.7275 16.3036 8.82375Z",
    fill: "#FF5023"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.21529dddf7799d8b21cf27ba05b267f8.svg";
export { ForwardRef as ReactComponent };